import _createClass from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
/**
 * Result object returned by UpdateQueryBuilder execution.
 */
export var QueryResult = /*#__PURE__*/_createClass(function QueryResult() {
  _classCallCheck(this, QueryResult);
  /**
   * Rows
   */
  this.records = [];
});